<template>
    <div>
        <!-- 通知通报 -->
        tongzhi 
    </div>
</template>

<script>
import { informBulletinDetail } from "@/api/public";
export default {
    data(){
        return {

        }
    },
    mounted() {
        // this.requestInformBulletinDetail()
    },
    methods:{
        // requestInformBulletinDetail() {
        //     informBulletinDetail({}).then(res=>{
        //         console.log(res)
        //     })
        // }
    }
}
</script>

<style scoped lang="scss">

</style>
